import React, {useState, useEffect} from 'react';
import Modal from 'react-bootstrap/Modal';
import { useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { FormTecnicoAvaliador } from '../components';
import Swal from 'sweetalert2';
import initialData from '../initialData';
import schema from './schema';
import {
  showTecnicoAvaliador, updateTecnicoAvaliador
} from '~/store/modules/tecnico_avaliador/action';

const Edit = () => {
  let history = useHistory();
  const dispatch = useDispatch();
  const { tecnico_avaliador_id } = useParams();
  const { user_auth } = useSelector(
    ({ LoginReducer }) => LoginReducer
  );
  const { tecnico_avaliador, errors, status_response } = useSelector(
    ({ TecnicoAvaliadorReducer }) => TecnicoAvaliadorReducer
  );
  const [updated, setUpdated] = useState(false);
  const [errorsForm, setErrors] = useState({});
  const [tecAvaliador, setTecAvaliador] = useState({
    ...initialData,
    entidade_id: user_auth.user.entidade_id
  });

  useEffect(() => {
    dispatch(
      showTecnicoAvaliador(
        tecnico_avaliador_id, {
          with: 'pessoa'
        }
      )
    );
  }, [dispatch, tecnico_avaliador_id]);

  useEffect(() => {
    const { pessoa, ...user } = tecnico_avaliador;
    const { cpf, cnpj, anexo_cpf, anexo_cnpj, ...tec_avaliador } = {
      ...user, ...pessoa,
      cpf_cnpj: pessoa?.cnpj || pessoa?.cpf,
      anexo_cpf_cnpj: pessoa?.anexo_cnpj || pessoa?.anexo_cpf
    };

    setTecAvaliador(tec_avaliador);
  }, [tecnico_avaliador]);

  useEffect(() => {
    if (errors.status && errors.status === 422) {
      let server_errors = {};
      const response_errors = errors.data.errors;

      for (let name of Object.keys(response_errors)) {
        Object.assign(
          server_errors, {
            [name]: response_errors[name][0]
          }
        );
      }

      setErrors(server_errors);
    }
    if(errors.update) {
      setUpdated(errors.update);
    }
  }, [errors, updated]);

  useEffect(() => {
    if (
      updated &&
      (status_response === 200 || status_response === 201)
    ) {
      Swal.fire(
        'Sucesso',
        'Registro salvo com sucesso!',
        'success'
      ).then(
        () => history.push('/tecnicos_avaliadores')
      );
    }
  }, [dispatch, updated, status_response, history]);

  const handleClose = () => {
    history.push('/tecnicos_avaliadores');
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!schema.isValidSync(tecAvaliador)) {
      let yup_errors = {};
      schema.validate(tecAvaliador, { abortEarly: false }).catch(err => {
        for (let error of err.inner) {
          const { path, message } = error;
          Object.assign(yup_errors, { [path]: message });
        }
        setErrors(yup_errors);
      });
    } else {
      const form = new FormData();
      form.append('_method', 'PUT');

      for (let key in tecAvaliador) {
        if (tecAvaliador[key]) {
          form.append(key, tecAvaliador[key]);
        }
      }
      dispatch(updateTecnicoAvaliador(
        tecnico_avaliador_id, form
      ));
    }
  }

  return (
    <Modal
      aria-labelledby="contained-modal-title-vcenter"
      dialogClassName="modal-xl"
      onHide={handleClose}
      show
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Editar Técnico Avaliador
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FormTecnicoAvaliador
          schema={schema}
          errors={errorsForm}
          handleSubmit={handleSubmit}
          tecnicoAvaliador={tecAvaliador}
          setTecnicoAvaliador={setTecAvaliador}
        />
      </Modal.Body>
    </Modal>
  );
};

export default Edit;
